import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FilterService} from "../../../../shared/services/filter.service";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {NgForm} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {delay, distinctUntilChanged, takeUntil, tap} from "rxjs/operators";
import {select, Store} from "@ngrx/store";
import {getCurrentRouteState} from "../../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../../shared/ngrx/route-serializer";
import {StoreRootState} from "../../../../shared/ngrx/reducers";
import {Profile} from "../../../../shared/interface/profile";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {AuthService} from "../../../../shared/services/auth.service";
import {DobryAgentBlogService} from "../../../../shared/services/dobry-agent-blog.service";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import {DobryAgentBlogArticle, DobryAgentBlogTag} from "../../../../shared/interface/dobry-agent-blog-article";
import {environment} from "../../../../../environments/environment";
import {Sort} from "@angular/material/sort";

@Component({
  selector: 'app-da-article-list',
  templateUrl: './da-article-list.component.html',
  styleUrls: ['./da-article-list.component.scss']
})
export class DaArticleListComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filtersForm') filtersForm: NgForm;

  initialFilters: any;
  displayedColumns: string[] = ['name', 'position', 'category', 'user', 'publicationDate', 'status', 'actions'];
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  userPermissions: ReplaySubject<UserPermissions>;
  profile: Profile;
  totalData = 0;
  posts: DobryAgentBlogArticle[] = [];
  sortBy = 'publicationDate';
  sortOrder = 'desc';

  constructor(
    private auth: AuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private filterService: FilterService,
    private store: Store<StoreRootState>,
    private dobryAgentBlogService: DobryAgentBlogService
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.auth.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.profile = profile;
      });
    this.dobryAgentBlogService.getBlogArticleListSubject()
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<DobryAgentBlogArticle>) => {
          this.posts = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }


  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      contains$name: 'string',
      contains$context: 'string',
      type: 'int',
      active: 'int',
      author: 'string',
      gte$createdAt: 'date',
      lte$createdAt: 'date',
      gte$publicationDate: 'date',
      lte$publicationDate: 'date',
      deleted: 'string',
      in$categories: 'string[]',
      in$tags: 'string[]',
    }, filters);
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.filtersForm.value
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }


  buildFilters(): any {
    const filters = {...this.initialFilters};

    return filters;
  }


  loadListData(): void {
    this.dobryAgentBlogService.loadList(
      this.paginator.pageIndex, this.paginator.pageSize,
      this.buildFilters(),
      {
        sortBy: this.sortBy,
        sortOrder: this.sortOrder
      }
    )
    ;
  }

  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }

  add(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }


  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }

  readonly environment = environment;

  sortChanged($event: Sort): void {
    this.sortBy = $event.active;
    this.sortOrder = $event.direction;

    this.loadListData();

  }


  restore(dobryAgentBlogArticle: DobryAgentBlogArticle): void {
    this.dobryAgentBlogService
      .confirmRestore(dobryAgentBlogArticle)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((restore: boolean) => {
        if (restore) {
          this.loadListData();
        }
      });
  }
  delete(dobryAgentBlogArticle: DobryAgentBlogArticle): void {
    this.dobryAgentBlogService
      .confirmDelete(dobryAgentBlogArticle)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((deleted: boolean) => {
        if (deleted) {
          this.loadListData();
        }
      });
  }

  deleteWeak(uuid: string): void {
    this.dobryAgentBlogService
      .confirmDeleteWeak(uuid)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((deleted: boolean) => {
        if (deleted) {
          this.loadListData();
        }
      });
  }
}
